import { Link2 } from "lucide-react"

const integrations = [
  {
    name: "Sage 300",
    description:
      "Sync employee data seamlessly with Sage 300. Automate payroll-ready onboarding and eliminate manual data entry.",
    logo: "/images/sage300.png",
    fallbackInitial: "S",
    color: "from-green-600 to-green-700",
  },
  {
    name: "Careers24",
    description:
      "Post vacancies directly to Careers24 and reach thousands of active job seekers across South Africa instantly.",
    logo: "/images/career24.png",
    fallbackInitial: "C",
    color: "from-blue-600 to-blue-700",
  },
  {
    name: "LinkedIn",
    description:
      "Share your job listings to LinkedIn with one click and tap into the world's largest professional network.",
    logo: "/images/linkedin.png",
    fallbackInitial: "in",
    color: "from-[#0077B5] to-[#005885]",
  },
]

export default function IntegrationsSection() {
  return (
    <section id="integrations" className="py-24 bg-gradient-to-br from-[#1b237a] via-[#1a2a8f] to-[#163b8f]">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {/* Heading */}
        <div className="mx-auto max-w-3xl text-center">
          <p className="text-md font-bold text-cyan-400 uppercase tracking-widest mb-3">
            Integrations
          </p>
          <h2 className="text-4xl sm:text-5xl font-bold text-white">
            Works with your existing tools
          </h2>
          <p className="mt-4 text-base text-white/70">
            Connect Tempered Talent with the platforms you already use — no
            complex setup required.
          </p>
        </div>

        {/* Cards */}
        <div className="mx-auto mt-16 grid max-w-lg grid-cols-1 gap-8 lg:max-w-none lg:grid-cols-3">
          {integrations.map((integration) => (
            <div
              key={integration.name}
              className="relative rounded-2xl bg-white/10 backdrop-blur-sm border border-white/20 p-8 hover:bg-white/15 transition-all duration-200"
            >
              {/* Icon */}
              <div className={`mb-5 flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br ${integration.color} shadow-lg`}>
                <span className="text-white font-bold text-sm">
                  {integration.fallbackInitial}
                </span>
              </div>

              <div className="flex items-center gap-2 mb-3">
                <Link2 className="h-4 w-4 text-cyan-400" />
                <h3 className="text-lg font-semibold text-white">
                  {integration.name}
                </h3>
              </div>

              <p className="text-sm text-white/70 leading-relaxed">
                {integration.description}
              </p>

              {/* Bottom accent */}
              <div className="absolute bottom-0 left-0 h-1 w-full rounded-b-2xl bg-gradient-to-r from-cyan-400 to-[#1A237E]" />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
